module.exports = __webpack_public_path__ + "static/img/DM.d95d9bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/DM.png
// module id = 0eV5
// module chunks = 34